import axios from 'axios';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import BatterTable from '../../../components/table/BatterTable';
import { flatObject } from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from '../../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import FuturesBatterTableWrapper from '../../../components/table/FuturesBatterTableWrapper';

function SituationFuturesBatterRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [situationRecord, setSituationRecord] = useState({});

    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();

    const teamObj = {
        'MIN_DOO': '두산',
        'MIN_LGT': 'LG',
        'MIN_LOT': '롯데',
        'MIN_SAM': '삼성',
        'MIN_HER': '키움',
        'MIN_HAN': '한화',
        'MIN_KIA': 'KIA',
        'MIN_KTW': 'KT',
        'MIN_NCD': 'NC',
        'MIN_HER': '고양',
        'MIN_SSG': 'SSG',
        'KBO_ARM': '상무'
    }

    useEffect(() => {
        let {playerId} = profile;

        let pitcherTypePromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresBatterPitcherTypeRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let opponentTeamPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresBatterPitcherTeamRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let homeOrArayPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresBatterHomeOrAwayRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        })

        let monthPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService', recordName: 'futuresBatterMonthRecord',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: 4206,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        })

        Promise.all([
            pitcherTypePromise,
            opponentTeamPromise,
            homeOrArayPromise,
            monthPromise
        ]).then((result) => {
            let tmpObj = {};
            tmpObj['pitcherType'] = result[0]['data']['result'];
            tmpObj['oppTeam'] = _.map(result[1]['data']['result'], (item) => {
                item['type'] = teamObj[item['pitcherTeam']];
                return item;
            });

            tmpObj['homeOrAway'] = _.map(result[2]['data']['result'], (item) => {
                item['type'] = item['groupingType'];
                return item;
            });

            tmpObj['month'] = _.map(result[3]['data']['result'], (item) => {
                item['type'] = item['groupingType'];
                return item;
            });

            setSituationRecord(tmpObj);
            setLoading(true);
        });
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setLoading(false);
        setSeason(value);
    }

    return (
        <>
        <div style={{position:'absolute', top: '-40px', right: '10px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        {
            !loading ?
            <div style={{height: '1000px'}}><DefaultLoader /></div> :
            <>
            <TableWrapper title={t('platoonSplits')+'-'+season}>
                <BatterTable data={situationRecord['pitcherType']} column={'futuresPitcherType'}/>
            </TableWrapper>
            <FuturesBatterTableWrapper title={t('pitchType')+'-'+season} column={'futuresBallCode'} profile={profile} season={season}/>
            <FuturesBatterTableWrapper title={t('pitchCount')+'-'+season} column={'futuresCount'} profile={profile} season={season}/>
            <TableWrapper title={t('homeoraway')+'-'+season}>
                <BatterTable data={situationRecord['homeOrAway']} column={'futuresHomeOrAway'}/>
            </TableWrapper>
            <TableWrapper title={t('opponent')+'-'+season}>
                <BatterTable data={situationRecord['oppTeam']} column={'futuresOppTeam'}/>
            </TableWrapper>
            <TableWrapper title={t('byMonth')+'-'+season}>
                <BatterTable data={situationRecord['month']} column={'futuresMonth'}/>
            </TableWrapper>
            </>
        }
        </>
    )
}

export default SituationFuturesBatterRecord;